module.exports = __webpack_public_path__ + "img/butter-coffee.e8cb5c12.jpg";